import React from "react";
import { useParams } from "react-router-dom";
import MasterLayout from "../masterLayout/MasterLayout";
import ComplainFormPageCloseUpdate from "../components/ComplainFormPageCloseUpdate";

const ComplainFormAssignedUpdate = () => {
  const { id } = useParams();

  return (
    <div>
      <MasterLayout>
        <ComplainFormPageCloseUpdate complainId={id} listPath="/assigned/list" />
      </MasterLayout>
    </div>
  );
};

export default ComplainFormAssignedUpdate;
